





















import { computed, ref } from "@vue/composition-api";
import Vue from "vue";
export default Vue.extend({
  props: ["value"],
  setup(props) {
    const level = ref(0);
    const level_img = computed(() => {
      switch (+(props as { value: number }).value) {
        case -1:
          return "var(--level-img-question)";
        case 0:
          return "var(--level-img-0)";
        case 1:
          return "var(--level-img-1)";
        case 2:
          return "var(--level-img-2)";
        case 3:
          return "var(--level-img-3)";
      }
    });

    return {
      level_img,
      level,
    };
  },
});
